export const apiFetchParams = {
  accessToken: "",
  baseApiUrl: "",
};
